import script from "./ViewStudentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewStudentView.vue?vue&type=script&lang=ts&setup=true"

import "./ViewStudentView.vue?vue&type=style&index=0&id=7f9d82e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f9d82e0"]])

export default __exports__